import { render } from "./UsuariosAdminView.vue?vue&type=template&id=052aeee8&ts=true"
import script from "./UsuariosAdminView.vue?vue&type=script&lang=ts"
export * from "./UsuariosAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__